import React from 'react';
import { signupCountries, SignupCountry } from '../../types/merchantSignup/MerchantSignup';
import { CountryButton, CountryGroup, Label } from './MerchantSignupPage.styles';

interface CountrySelectProps {
    value: SignupCountry;
    onChange: (country: SignupCountry) => void;
}

const countryNames: Record<SignupCountry, string> = {
    SE: 'Sweden',
    NO: 'Norway',
    FI: 'Finland',
    DK: 'Denmark',
};

/** Single-select toggle buttons: the pressed one is the chosen country. */
const CountrySelect: React.FC<CountrySelectProps> = ({ value, onChange }: CountrySelectProps) => (
    <>
        <Label as="span" id="signup-country-label">
            Country
        </Label>
        <CountryGroup role="group" aria-labelledby="signup-country-label">
            {signupCountries.map(country => (
                <CountryButton
                    key={country}
                    type="button"
                    aria-pressed={value === country}
                    aria-label={countryNames[country]}
                    onClick={() => onChange(country)}
                >
                    {country}
                </CountryButton>
            ))}
        </CountryGroup>
    </>
);

export default CountrySelect;
